import { ChangeDetectionStrategy, Component } from '@angular/core';

import { CcsHelpItemComponent } from '../ccs-help-item/ccs-help-item.component';
import { CcsHelpSkeletonComponent } from '../ccs-help-skeleton/ccs-help-skeleton.component';
import { ccsHelpState } from '../../shared/helpers';

@Component({
  selector: 'app-ccs-help-list',
  imports: [CcsHelpItemComponent, CcsHelpSkeletonComponent],
  template: `
    @if (ccsHelpState.isLoading()) {
      <app-ccs-help-skeleton />
    } @else {
      <app-ccs-help-item />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsHelpListComponent {
  protected readonly ccsHelpState = ccsHelpState();
}
